import { computed, inject, Injectable } from '@angular/core';

import { AbilityFacade } from '@core/abilities-legacy';
import { Ability } from '@core/abilities-types';
import { injectDevFlag } from '@core/dev-flags-logic';
import { DevFlag } from '@core/dev-flags-types';
import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { FeatureCode, WorkflowAutomationsAllowedContext } from '@core/feature-spec-types';

@Injectable({
  providedIn: 'root',
})
export class WorkflowAutomationsAccessFacade {
  private readonly featureSpecFacade = inject(FeatureSpecFacade);
  private readonly abilityFacade = inject(AbilityFacade);

  private readonly hasWorkflowAutomations = injectDevFlag(DevFlag.WorkflowAutomations);
  private readonly automationsConfig = this.featureSpecFacade.selectConfig(
    FeatureCode.WorkflowAutomations,
  );

  public readonly workflowAutomationsEntitled = this.featureSpecFacade.selectIsEntitled(
    FeatureCode.WorkflowAutomations,
  );

  public readonly hasManageAutomatedActions = this.abilityFacade.checkAbility(
    Ability.ManageAutomatedActions,
  );

  public readonly hasJobEditorAutomations = computed(
    () =>
      this.hasWorkflowAutomations &&
      !!this.automationsConfig()?.contexts?.includes(WorkflowAutomationsAllowedContext.Jobs),
  );

  public readonly hasJobTemplateEditorAutomations = computed(
    () =>
      this.hasWorkflowAutomations &&
      !!this.automationsConfig()?.contexts?.includes(
        WorkflowAutomationsAllowedContext.JobTemplates,
      ),
  );
  public readonly hasPipelineTemplatesAutomations = computed(
    () =>
      this.hasWorkflowAutomations &&
      !!this.automationsConfig()?.contexts?.includes(
        WorkflowAutomationsAllowedContext.PipelineTemplates,
      ),
  );
  public readonly hasDisqualifyReasonAutomations = computed(
    () =>
      this.hasWorkflowAutomations &&
      !!this.automationsConfig()?.contexts?.includes(
        WorkflowAutomationsAllowedContext.DisqualifyReasons,
      ),
  );

  public readonly automationsSectionVisibleInJobEditors = computed(
    () => this.hasJobEditorAutomations() || this.hasJobTemplateEditorAutomations(),
  );
}
